















































import { Vue, Component, Prop } from 'vue-property-decorator';
import Modal from '@/components/Modal.vue';
import Icon from '@/components/Icon.vue';
import idealName from '@/utils/ideal-name';
import { Agent } from '@/store/modules/agent';
import {
    TimelineEntry,
    timelineIconName,
    timelineIconClass,
    timelineTime,
} from '@/utils/agent/timeline';

@Component({
    components: {
        Modal,
        Icon,
    },
})
export default class ModalTimeline extends Vue {
    @Prop() readonly agent!: Agent;

    idealName = idealName;

    iconName = timelineIconName;

    iconClass = timelineIconClass;

    formatTime = timelineTime;

    entries: Array<TimelineEntry> = [];

    isLoading = false;

    toogleModal() {
        const modal = this.$refs.modalTimeline as Modal;
        modal.toogleModal();

        // se pide al abrir y no al montar: la bitacora cambia mientras el
        // panel esta abierto y no vale la pena mantenerla sincronizada.
        if (modal.isOpen) this.fetch();
    }

    fetch() {
        const { channel } = this.$store.getters.getAgentByName(this.agent.name) || {};

        if (!channel) {
            this.entries = [];
            return;
        }

        this.isLoading = true;

        channel.push('get_agent_timeline', {})
            .receive('ok', (res: { timeline: Array<TimelineEntry> }) => {
                this.entries = res.timeline || [];
                this.isLoading = false;
            })
            .receive('error', () => {
                this.entries = [];
                this.isLoading = false;
            })
            .receive('timeout', () => {
                this.entries = [];
                this.isLoading = false;
            });
    }

    label(entry: TimelineEntry): string {
        switch (entry.k) {
            // entradas escritas antes de unificar la pausa en el estado,
            // siguen vivas en redis hasta 24hs despues del deploy.
            case 'dnd':
                if (entry.v !== 'enabled') return this.$t('agent.timeline.dnd_disabled') as string;
                return entry.s
                    ? this.$t('agent.timeline.dnd_enabled_with_reason', { reason: entry.s }) as string
                    : this.$t('agent.timeline.dnd_enabled') as string;
            case 'tier':
                return this.$t(
                    entry.v === 'ready' ? 'agent.timeline.tier_ready' : 'agent.timeline.tier_standby',
                    { queue: this.queueName(entry.q) },
                ) as string;
            case 'call_in':
                return this.$t(
                    entry.v === 'ended' ? 'agent.timeline.call_in_ended' : 'agent.timeline.call_in',
                    { queue: this.queueName(entry.q), number: entry.n || '' },
                ) as string;
            case 'call_out':
                return this.$t(
                    entry.v === 'ended' ? 'agent.timeline.call_out_ended' : 'agent.timeline.call_out',
                    { number: entry.n || '' },
                ) as string;
            case 'registration':
                return this.$t(
                    entry.v === 'registered'
                        ? 'agent.timeline.registered'
                        : 'agent.timeline.unregistered',
                ) as string;
            default:
                return this.statusEntryLabel(entry);
        }
    }

    // la pausa es un estado de no disponible, con el motivo como substatus.
    statusEntryLabel(entry: TimelineEntry): string {
        if (entry.v !== 'unavailable') {
            return this.$t('agent.timeline.status', { status: this.statusLabel(entry.v) }) as string;
        }

        return entry.s
            ? this.$t('agent.timeline.dnd_enabled_with_reason', { reason: entry.s }) as string
            : this.$t('agent.timeline.dnd_enabled') as string;
    }

    // el estado crudo de freeswitch es el substatus, si no lo conocemos
    // se muestra tal cual en vez de esconderlo detras de un generico.
    statusLabel(status: string): string {
        const key = `agent.status.${status.toLowerCase()}`;
        const translated = this.$t(key) as string;

        return translated === key ? status : translated;
    }

    queueName(queue?: string): string {
        if (!queue) return '';

        return this.$store.getters.queueName(queue) || queue;
    }
}
